export const countriesEnglish = [
    { textField: 'Afghanistan', valueField: 'AF' },
    { textField: 'Åland Islands', valueField: 'AX' },
    { textField: 'Albania', valueField: 'AL' },
    { textField: 'Algeria', valueField: 'DZ' },
    { textField: 'American Samoa', valueField: 'AS' },
    { textField: 'Andorra', valueField: 'AD' },
    { textField: 'Angola', valueField: 'AO' },
    { textField: 'Anguilla', valueField: 'AI' },
    { textField: 'Antarctica', valueField: 'AQ' },
    { textField: 'Antigua and Barbuda', valueField: 'AG' },
    { textField: 'Argentina', valueField: 'AR' },
    { textField: 'Armenia', valueField: 'AM' },
    { textField: 'Aruba', valueField: 'AW' },
    { textField: 'Australia', valueField: 'AU' },
    { textField: 'Austria', valueField: 'AT' },
    { textField: 'Azerbaijan', valueField: 'AZ' },
    { textField: 'Bahamas', valueField: 'BS' },
    { textField: 'Bahrain', valueField: 'BH' },
    { textField: 'Bangladesh', valueField: 'BD' },
    { textField: 'Barbados', valueField: 'BB' },
    { textField: 'Belarus', valueField: 'BY' },
    { textField: 'Belgium', valueField: 'BE' },
    { textField: 'Belize', valueField: 'BZ' },
    { textField: 'Benin', valueField: 'BJ' },
    { textField: 'Bermuda', valueField: 'BM' },
    { textField: 'Bhutan', valueField: 'BT' },
    { textField: 'Bolivia', valueField: 'BO' },
    { textField: 'Bonaire, Sint Eustatius and Saba', valueField: 'BQ' },
    { textField: 'Bosnia and Herzegovina', valueField: 'BA' },
    { textField: 'Botswana', valueField: 'BW' },
    { textField: 'Bouvet Island', valueField: 'BV' },
    { textField: 'Brazil', valueField: 'BR' },
    { textField: 'British Indian Ocean Territory', valueField: 'IO' },
    { textField: 'Brunei Darussalam', valueField: 'BN' },
    { textField: 'Bulgaria', valueField: 'BG' },
    { textField: 'Burkina Faso', valueField: 'BF' },
    { textField: 'Burundi', valueField: 'BI' },
    { textField: 'Cabo Verde', valueField: 'CV' },
    { textField: 'Cambodia', valueField: 'KH' },
    { textField: 'Cameroon', valueField: 'CM' },
    { textField: 'Canada', valueField: 'CA' },
    { textField: 'Cayman Islands', valueField: 'KY' },
    { textField: 'Central African Republic', valueField: 'CF' },
    { textField: 'Chad', valueField: 'TD' },
    { textField: 'Chile', valueField: 'CL' },
    { textField: 'China', valueField: 'CN' },
    { textField: 'Christmas Island', valueField: 'CX' },
    { textField: 'Cocos (Keeling) Islands', valueField: 'CC' },
    { textField: 'Colombia', valueField: 'CO' },
    { textField: 'Comoros', valueField: 'KM' },
    { textField: 'Congo', valueField: 'CG' },
    { textField: 'Congo, Democratic Republic of the', valueField: 'CD' },
    { textField: 'Cook Islands', valueField: 'CK' },
    { textField: 'Costa Rica', valueField: 'CR' },
    { textField: "Côte d'Ivoire", valueField: 'CI' },
    { textField: 'Croatia', valueField: 'HR' },
    { textField: 'Cuba', valueField: 'CU' },
    { textField: 'Curaçao', valueField: 'CW' },
    { textField: 'Cyprus', valueField: 'CY' },
    { textField: 'Czechia', valueField: 'CZ' },
    { textField: 'Denmark', valueField: 'DK' },
    { textField: 'Djibouti', valueField: 'DJ' },
    { textField: 'Dominica', valueField: 'DM' },
    { textField: 'Dominican Republic', valueField: 'DO' },
    { textField: 'Ecuador', valueField: 'EC' },
    { textField: 'Egypt', valueField: 'EG' },
    { textField: 'El Salvador', valueField: 'SV' },
    { textField: 'Equatorial Guinea', valueField: 'GQ' },
    { textField: 'Eritrea', valueField: 'ER' },
    { textField: 'Estonia', valueField: 'EE' },
    { textField: 'Eswatini', valueField: 'SZ' },
    { textField: 'Ethiopia', valueField: 'ET' },
    { textField: 'Falkland Islands', valueField: 'FK' },
    { textField: 'Faroe Islands', valueField: 'FO' },
    { textField: 'Fiji', valueField: 'FJ' },
    { textField: 'Finland', valueField: 'FI' },
    { textField: 'France', valueField: 'FR' },
    { textField: 'French Guiana', valueField: 'GF' },
    { textField: 'French Polynesia', valueField: 'PF' },
    { textField: 'French Southern Territories', valueField: 'TF' },
    { textField: 'Gabon', valueField: 'GA' },
    { textField: 'Gambia', valueField: 'GM' },
    { textField: 'Georgia', valueField: 'GE' },
    { textField: 'Germany', valueField: 'DE' },
    { textField: 'Ghana', valueField: 'GH' },
    { textField: 'Gibraltar', valueField: 'GI' },
    { textField: 'Greece', valueField: 'GR' },
    { textField: 'Greenland', valueField: 'GL' },
    { textField: 'Grenada', valueField: 'GD' },
    { textField: 'Guadeloupe', valueField: 'GP' },
    { textField: 'Guam', valueField: 'GU' },
    { textField: 'Guatemala', valueField: 'GT' },
    { textField: 'Guernsey', valueField: 'GG' },
    { textField: 'Guinea', valueField: 'GN' },
    { textField: 'Guinea-Bissau', valueField: 'GW' },
    { textField: 'Guyana', valueField: 'GY' },
    { textField: 'Haiti', valueField: 'HT' },
    { textField: 'Heard Island and McDonald Islands', valueField: 'HM' },
    { textField: 'Holy See', valueField: 'VA' },
    { textField: 'Honduras', valueField: 'HN' },
    { textField: 'Hong Kong', valueField: 'HK' },
    { textField: 'Hungary', valueField: 'HU' },
    { textField: 'Iceland', valueField: 'IS' },
    { textField: 'India', valueField: 'IN' },
    { textField: 'Indonesia', valueField: 'ID' },
    { textField: 'Iran', valueField: 'IR' },
    { textField: 'Iraq', valueField: 'IQ' },
    { textField: 'Ireland', valueField: 'IE' },
    { textField: 'Isle of Man', valueField: 'IM' },
    { textField: 'Israel', valueField: 'IL' },
    { textField: 'Italy', valueField: 'IT' },
    { textField: 'Jamaica', valueField: 'JM' },
    { textField: 'Japan', valueField: 'JP' },
    { textField: 'Jersey', valueField: 'JE' },
    { textField: 'Jordan', valueField: 'JO' },
    { textField: 'Kazakhstan', valueField: 'KZ' },
    { textField: 'Kenya', valueField: 'KE' },
    { textField: 'Kiribati', valueField: 'KI' },
    { textField: "Korea, Democratic People's Republic of", valueField: 'KP' },
    { textField: 'Korea, Republic of', valueField: 'KR' },
    { textField: 'Kuwait', valueField: 'KW' },
    { textField: 'Kyrgyzstan', valueField: 'KG' },
    { textField: "Lao People's Democratic Republic", valueField: 'LA' },
    { textField: 'Latvia', valueField: 'LV' },
    { textField: 'Lebanon', valueField: 'LB' },
    { textField: 'Lesotho', valueField: 'LS' },
    { textField: 'Liberia', valueField: 'LR' },
    { textField: 'Libya', valueField: 'LY' },
    { textField: 'Liechtenstein', valueField: 'LI' },
    { textField: 'Lithuania', valueField: 'LT' },
    { textField: 'Luxembourg', valueField: 'LU' },
    { textField: 'Macao', valueField: 'MO' },
    { textField: 'North Macedonia', valueField: 'MK' },
    { textField: 'Madagascar', valueField: 'MG' },
    { textField: 'Malawi', valueField: 'MW' },
    { textField: 'Malaysia', valueField: 'MY' },
    { textField: 'Maldives', valueField: 'MV' },
    { textField: 'Mali', valueField: 'ML' },
    { textField: 'Malta', valueField: 'MT' },
    { textField: 'Marshall Islands', valueField: 'MH' },
    { textField: 'Martinique', valueField: 'MQ' },
    { textField: 'Mauritania', valueField: 'MR' },
    { textField: 'Mauritius', valueField: 'MU' },
    { textField: 'Mayotte', valueField: 'YT' },
    { textField: 'Mexico', valueField: 'MX' },
    { textField: 'Micronesia', valueField: 'FM' },
    { textField: 'Moldova', valueField: 'MD' },
    { textField: 'Monaco', valueField: 'MC' },
    { textField: 'Mongolia', valueField: 'MN' },
    { textField: 'Montenegro', valueField: 'ME' },
    { textField: 'Montserrat', valueField: 'MS' },
    { textField: 'Morocco', valueField: 'MA' },
    { textField: 'Mozambique', valueField: 'MZ' },
    { textField: 'Myanmar', valueField: 'MM' },
    { textField: 'Namibia', valueField: 'NA' },
    { textField: 'Nauru', valueField: 'NR' },
    { textField: 'Nepal', valueField: 'NP' },
    { textField: 'Netherlands', valueField: 'NL' },
    { textField: 'New Caledonia', valueField: 'NC' },
    { textField: 'New Zealand', valueField: 'NZ' },
    { textField: 'Nicaragua', valueField: 'NI' },
    { textField: 'Niger', valueField: 'NE' },
    { textField: 'Nigeria', valueField: 'NG' },
    { textField: 'Niue', valueField: 'NU' },
    { textField: 'Norfolk Island', valueField: 'NF' },
    { textField: 'Northern Mariana Islands', valueField: 'MP' },
    { textField: 'Norway', valueField: 'NO' },
    { textField: 'Oman', valueField: 'OM' },
    { textField: 'Pakistan', valueField: 'PK' },
    { textField: 'Palau', valueField: 'PW' },
    { textField: 'Palestine, State of', valueField: 'PS' },
    { textField: 'Panama', valueField: 'PA' },
    { textField: 'Papua New Guinea', valueField: 'PG' },
    { textField: 'Paraguay', valueField: 'PY' },
    { textField: 'Peru', valueField: 'PE' },
    { textField: 'Philippines', valueField: 'PH' },
    { textField: 'Pitcairn', valueField: 'PN' },
    { textField: 'Poland', valueField: 'PL' },
    { textField: 'Portugal', valueField: 'PT' },
    { textField: 'Puerto Rico', valueField: 'PR' },
    { textField: 'Qatar', valueField: 'QA' },
    { textField: 'Réunion', valueField: 'RE' },
    { textField: 'Romania', valueField: 'RO' },
    { textField: 'Russian Federation', valueField: 'RU' },
    { textField: 'Rwanda', valueField: 'RW' },
    { textField: 'Saint Barthélemy', valueField: 'BL' },
    {
        textField: 'Saint Helena, Ascension and Tristan da Cunha',
        valueField: 'SH',
    },
    { textField: 'Saint Kitts and Nevis', valueField: 'KN' },
    { textField: 'Saint Lucia', valueField: 'LC' },
    { textField: 'Saint Martin (French part)', valueField: 'MF' },
    { textField: 'Saint Pierre and Miquelon', valueField: 'PM' },
    { textField: 'Saint Vincent and the Grenadines', valueField: 'VC' },
    { textField: 'Samoa', valueField: 'WS' },
    { textField: 'San Marino', valueField: 'SM' },
    { textField: 'Sao Tome and Principe', valueField: 'ST' },
    { textField: 'Saudi Arabia', valueField: 'SA' },
    { textField: 'Senegal', valueField: 'SN' },
    { textField: 'Serbia', valueField: 'RS' },
    { textField: 'Seychelles', valueField: 'SC' },
    { textField: 'Sierra Leone', valueField: 'SL' },
    { textField: 'Singapore', valueField: 'SG' },
    { textField: 'Sint Maarten (Dutch part)', valueField: 'SX' },
    { textField: 'Slovakia', valueField: 'SK' },
    { textField: 'Slovenia', valueField: 'SI' },
    { textField: 'Solomon Islands', valueField: 'SB' },
    { textField: 'Somalia', valueField: 'SO' },
    { textField: 'South Africa', valueField: 'ZA' },
    {
        textField: 'South Georgia and the South Sandwich Islands',
        valueField: 'GS',
    },
    { textField: 'South Sudan', valueField: 'SS' },
    { textField: 'Spain', valueField: 'ES' },
    { textField: 'Sri Lanka', valueField: 'LK' },
    { textField: 'Sudan', valueField: 'SD' },
    { textField: 'Suriname', valueField: 'SR' },
    { textField: 'Svalbard and Jan Mayen', valueField: 'SJ' },
    { textField: 'Sweden', valueField: 'SE' },
    { textField: 'Switzerland', valueField: 'CH' },
    { textField: 'Syrian Arab Republic', valueField: 'SY' },
    { textField: 'Taiwan', valueField: 'TW' },
    { textField: 'Tajikistan', valueField: 'TJ' },
    { textField: 'Tanzania, the United Republic of', valueField: 'TZ' },
    { textField: 'Thailand', valueField: 'TH' },
    { textField: 'Timor-Leste', valueField: 'TL' },
    { textField: 'Togo', valueField: 'TG' },
    { textField: 'Tokelau', valueField: 'TK' },
    { textField: 'Tonga', valueField: 'TO' },
    { textField: 'Trinidad and Tobago', valueField: 'TT' },
    { textField: 'Tunisia', valueField: 'TN' },
    { textField: 'Turkey', valueField: 'TR' },
    { textField: 'Turkmenistan', valueField: 'TM' },
    { textField: 'Turks and Caicos Islands', valueField: 'TC' },
    { textField: 'Tuvalu', valueField: 'TV' },
    { textField: 'Uganda', valueField: 'UG' },
    { textField: 'Ukraine', valueField: 'UA' },
    { textField: 'United Arab Emirates', valueField: 'AE' },
    {
        textField: 'United Kingdom of Great Britain and Northern Ireland',
        valueField: 'GB',
    },
    { textField: 'United States Minor Outlying Islands', valueField: 'UM' },
    { textField: 'United States of America', valueField: 'US' },
    { textField: 'Uruguay', valueField: 'UY' },
    { textField: 'Uzbekistan', valueField: 'UZ' },
    { textField: 'Vanuatu', valueField: 'VU' },
    { textField: 'Venezuela', valueField: 'VE' },
    { textField: 'Viet Nam', valueField: 'VN' },
    { textField: 'Virgin Islands (British)', valueField: 'VG' },
    { textField: 'Virgin Islands (U.S.)', valueField: 'VI' },
    { textField: 'Wallis and Futuna', valueField: 'WF' },
    { textField: 'Western Sahara', valueField: 'EH' },
    { textField: 'Yemen', valueField: 'YE' },
    { textField: 'Zambia', valueField: 'ZM' },
    { textField: 'Zimbabwe', valueField: 'ZW' },
];

export const countriesFrench = [
    { textField: 'Afghanistan', valueField: 'AF' },
    { textField: 'Afrique du Sud', valueField: 'ZA' },
    { textField: 'Albanie', valueField: 'AL' },
    { textField: 'Algérie', valueField: 'DZ' },
    { textField: 'Allemagne', valueField: 'DE' },
    { textField: 'Andorre', valueField: 'AD' },
    { textField: 'Angola', valueField: 'AO' },
    { textField: 'Anguilla', valueField: 'AI' },
    { textField: 'Antarctique', valueField: 'AQ' },
    { textField: 'Antigua-et-Barbuda', valueField: 'AG' },
    { textField: 'Arabie saoudite', valueField: 'SA' },
    { textField: 'Argentine', valueField: 'AR' },
    { textField: 'Arménie', valueField: 'AM' },
    { textField: 'Aruba', valueField: 'AW' },
    { textField: 'Australie', valueField: 'AU' },
    { textField: 'Autriche', valueField: 'AT' },
    { textField: 'Azerbaïdjan', valueField: 'AZ' },
    { textField: 'Bahamas', valueField: 'BS' },
    { textField: 'Bahreïn', valueField: 'BH' },
    { textField: 'Bangladesh', valueField: 'BD' },
    { textField: 'Barbade', valueField: 'BB' },
    { textField: 'Belgique', valueField: 'BE' },
    { textField: 'Belize', valueField: 'BZ' },
    { textField: 'Bénin', valueField: 'BJ' },
    { textField: 'Bermudes', valueField: 'BM' },
    { textField: 'Bhoutan', valueField: 'BT' },
    { textField: 'Biélorussie', valueField: 'BY' },
    { textField: 'Birmanie', valueField: 'MM' },
    { textField: 'Bolivie', valueField: 'BO' },
    { textField: 'Bosnie-Herzégovine', valueField: 'BA' },
    { textField: 'Botswana', valueField: 'BW' },
    { textField: 'Brésil', valueField: 'BR' },
    { textField: 'Brunei', valueField: 'BN' },
    { textField: 'Bulgarie', valueField: 'BG' },
    { textField: 'Burkina Faso', valueField: 'BF' },
    { textField: 'Burundi', valueField: 'BI' },
    { textField: 'Cambodge', valueField: 'KH' },
    { textField: 'Cameroun', valueField: 'CM' },
    { textField: 'Canada', valueField: 'CA' },
    { textField: 'Cap-Vert', valueField: 'CV' },
    { textField: 'Chili', valueField: 'CL' },
    { textField: 'Chine', valueField: 'CN' },
    { textField: 'Chypre', valueField: 'CY' },
    { textField: 'Colombie', valueField: 'CO' },
    { textField: 'Comores', valueField: 'KM' },
    { textField: 'Congo', valueField: 'CG' },
    { textField: 'Congo, République démocratique du', valueField: 'CD' },
    { textField: 'Corée du Nord', valueField: 'KP' },
    { textField: 'Corée du Sud', valueField: 'KR' },
    { textField: 'Costa Rica', valueField: 'CR' },
    { textField: "Côte d'Ivoire", valueField: 'CI' },
    { textField: 'Croatie', valueField: 'HR' },
    { textField: 'Cuba', valueField: 'CU' },
    { textField: 'Curaçao', valueField: 'CW' },
    { textField: 'Danemark', valueField: 'DK' },
    { textField: 'Djibouti', valueField: 'DJ' },
    { textField: 'Dominique', valueField: 'DM' },
    { textField: 'Égypte', valueField: 'EG' },
    { textField: 'Émirats arabes unis', valueField: 'AE' },
    { textField: 'Équateur', valueField: 'EC' },
    { textField: 'Érythrée', valueField: 'ER' },
    { textField: 'Espagne', valueField: 'ES' },
    { textField: 'Estonie', valueField: 'EE' },
    { textField: 'Eswatini', valueField: 'SZ' },
    { textField: 'États fédérés de Micronésie', valueField: 'FM' },
    { textField: 'États-Unis', valueField: 'US' },
    { textField: 'Éthiopie', valueField: 'ET' },
    { textField: 'Fidji', valueField: 'FJ' },
    { textField: 'Finlande', valueField: 'FI' },
    { textField: 'France', valueField: 'FR' },
    { textField: 'Gabon', valueField: 'GA' },
    { textField: 'Gambie', valueField: 'GM' },
    { textField: 'Géorgie', valueField: 'GE' },
    {
        textField: 'Géorgie du Sud-et-les îles Sandwich du Sud',
        valueField: 'GS',
    },
    { textField: 'Ghana', valueField: 'GH' },
    { textField: 'Gibraltar', valueField: 'GI' },
    { textField: 'Grèce', valueField: 'GR' },
    { textField: 'Grenade', valueField: 'GD' },
    { textField: 'Groenland', valueField: 'GL' },
    { textField: 'Guadeloupe', valueField: 'GP' },
    { textField: 'Guam', valueField: 'GU' },
    { textField: 'Guatemala', valueField: 'GT' },
    { textField: 'Guernesey', valueField: 'GG' },
    { textField: 'Guinée', valueField: 'GN' },
    { textField: 'Guinée équatoriale', valueField: 'GQ' },
    { textField: 'Guinée-Bissau', valueField: 'GW' },
    { textField: 'Guyana', valueField: 'GY' },
    { textField: 'Guyane', valueField: 'GF' },
    { textField: 'Haïti', valueField: 'HT' },
    { textField: 'Honduras', valueField: 'HN' },
    { textField: 'Hong Kong', valueField: 'HK' },
    { textField: 'Hongrie', valueField: 'HU' },
    { textField: 'Île Bouvet', valueField: 'BV' },
    { textField: 'Île Christmas', valueField: 'CX' },
    { textField: 'Île de Man', valueField: 'IM' },
    { textField: 'Île Norfolk', valueField: 'NF' },
    { textField: 'Îles Åland', valueField: 'AX' },
    { textField: 'Îles Caïmans', valueField: 'KY' },
    { textField: 'Îles Cocos', valueField: 'CC' },
    { textField: 'Îles Cook', valueField: 'CK' },
    { textField: 'Îles Féroé', valueField: 'FO' },
    { textField: 'Îles Heard-et-MacDonald', valueField: 'HM' },
    { textField: 'Îles Mariannes du Nord', valueField: 'MP' },
    { textField: 'Îles Marshall', valueField: 'MH' },
    { textField: 'Îles mineures éloignées des États-Unis', valueField: 'UM' },
    { textField: 'Îles Pitcairn', valueField: 'PN' },
    { textField: 'Îles Salomon', valueField: 'SB' },
    { textField: 'Îles Turques-et-Caïques', valueField: 'TC' },
    { textField: 'Îles Vierges britanniques', valueField: 'VG' },
    { textField: 'Îles Vierges des États-Unis', valueField: 'VI' },
    { textField: 'Inde', valueField: 'IN' },
    { textField: 'Indonésie', valueField: 'ID' },
    { textField: 'Irak', valueField: 'IQ' },
    { textField: 'Iran', valueField: 'IR' },
    { textField: 'Irlande', valueField: 'IE' },
    { textField: 'Islande', valueField: 'IS' },
    { textField: 'Israël', valueField: 'IL' },
    { textField: 'Italie', valueField: 'IT' },
    { textField: 'Jamaïque', valueField: 'JM' },
    { textField: 'Japon', valueField: 'JP' },
    { textField: 'Jersey', valueField: 'JE' },
    { textField: 'Jordanie', valueField: 'JO' },
    { textField: 'Kazakhstan', valueField: 'KZ' },
    { textField: 'Kenya', valueField: 'KE' },
    { textField: 'Kirghizistan', valueField: 'KG' },
    { textField: 'Kiribati', valueField: 'KI' },
    { textField: 'Koweït', valueField: 'KW' },
    { textField: 'La Réunion', valueField: 'RE' },
    { textField: 'Laos', valueField: 'LA' },
    { textField: 'Lesotho', valueField: 'LS' },
    { textField: 'Lettonie', valueField: 'LV' },
    { textField: 'Liban', valueField: 'LB' },
    { textField: 'Liberia', valueField: 'LR' },
    { textField: 'Libye', valueField: 'LY' },
    { textField: 'Liechtenstein', valueField: 'LI' },
    { textField: 'Lituanie', valueField: 'LT' },
    { textField: 'Luxembourg', valueField: 'LU' },
    { textField: 'Macao', valueField: 'MO' },
    { textField: 'Macédoine du Nord', valueField: 'MK' },
    { textField: 'Madagascar', valueField: 'MG' },
    { textField: 'Malaisie', valueField: 'MY' },
    { textField: 'Malawi', valueField: 'MW' },
    { textField: 'Maldives', valueField: 'MV' },
    { textField: 'Mali', valueField: 'ML' },
    { textField: 'Malouines', valueField: 'FK' },
    { textField: 'Malte', valueField: 'MT' },
    { textField: 'Maroc', valueField: 'MA' },
    { textField: 'Martinique', valueField: 'MQ' },
    { textField: 'Maurice', valueField: 'MU' },
    { textField: 'Mauritanie', valueField: 'MR' },
    { textField: 'Mayotte', valueField: 'YT' },
    { textField: 'Mexique', valueField: 'MX' },
    { textField: 'Moldavie', valueField: 'MD' },
    { textField: 'Monaco', valueField: 'MC' },
    { textField: 'Mongolie', valueField: 'MN' },
    { textField: 'Monténégro', valueField: 'ME' },
    { textField: 'Montserrat', valueField: 'MS' },
    { textField: 'Mozambique', valueField: 'MZ' },
    { textField: 'Namibie', valueField: 'NA' },
    { textField: 'Nauru', valueField: 'NR' },
    { textField: 'Népal', valueField: 'NP' },
    { textField: 'Nicaragua', valueField: 'NI' },
    { textField: 'Niger', valueField: 'NE' },
    { textField: 'Nigeria', valueField: 'NG' },
    { textField: 'Niue', valueField: 'NU' },
    { textField: 'Norvège', valueField: 'NO' },
    { textField: 'Nouvelle-Calédonie', valueField: 'NC' },
    { textField: 'Nouvelle-Zélande', valueField: 'NZ' },
    { textField: 'Oman', valueField: 'OM' },
    { textField: 'Ouganda', valueField: 'UG' },
    { textField: 'Ouzbékistan', valueField: 'UZ' },
    { textField: 'Pakistan', valueField: 'PK' },
    { textField: 'Palaos', valueField: 'PW' },
    { textField: 'Palestine', valueField: 'PS' },
    { textField: 'Panama', valueField: 'PA' },
    { textField: 'Papouasie-Nouvelle-Guinée', valueField: 'PG' },
    { textField: 'Paraguay', valueField: 'PY' },
    { textField: 'Pays-Bas', valueField: 'NL' },
    { textField: 'Pays-Bas caribéens', valueField: 'BQ' },
    { textField: 'Pérou', valueField: 'PE' },
    { textField: 'Philippines', valueField: 'PH' },
    { textField: 'Pologne', valueField: 'PL' },
    { textField: 'Polynésie française', valueField: 'PF' },
    { textField: 'Porto Rico', valueField: 'PR' },
    { textField: 'Portugal', valueField: 'PT' },
    { textField: 'Qatar', valueField: 'QA' },
    { textField: 'République arabe sahraouie démocratique', valueField: 'EH' },
    { textField: 'République centrafricaine', valueField: 'CF' },
    { textField: 'République dominicaine', valueField: 'DO' },
    { textField: 'Roumanie', valueField: 'RO' },
    { textField: 'Royaume-Uni', valueField: 'GB' },
    { textField: 'Russie', valueField: 'RU' },
    { textField: 'Rwanda', valueField: 'RW' },
    { textField: 'Saint-Barthélemy', valueField: 'BL' },
    { textField: 'Saint-Christophe-et-Niévès', valueField: 'KN' },
    { textField: 'Saint-Marin', valueField: 'SM' },
    { textField: 'Saint-Martin (Partie Française)', valueField: 'MF' },
    { textField: 'Saint-Martin (Partie Néerlandaise)', valueField: 'SX' },
    { textField: 'Saint-Pierre-et-Miquelon', valueField: 'PM' },
    { textField: 'Saint-Siège', valueField: 'VA' },
    { textField: 'Saint-Vincent-et-les-Grenadines', valueField: 'VC' },
    {
        textField: 'Sainte-Hélène, Ascension et Tristan da Cunha',
        valueField: 'SH',
    },
    { textField: 'Sainte-Lucie', valueField: 'LC' },
    { textField: 'Salvador', valueField: 'SV' },
    { textField: 'Samoa', valueField: 'WS' },
    { textField: 'Samoa américaines', valueField: 'AS' },
    { textField: 'Sao Tomé-et-Principe', valueField: 'ST' },
    { textField: 'Sénégal', valueField: 'SN' },
    { textField: 'Serbie', valueField: 'RS' },
    { textField: 'Seychelles', valueField: 'SC' },
    { textField: 'Sierra Leone', valueField: 'SL' },
    { textField: 'Singapour', valueField: 'SG' },
    { textField: 'Slovaquie', valueField: 'SK' },
    { textField: 'Slovénie', valueField: 'SI' },
    { textField: 'Somalie', valueField: 'SO' },
    { textField: 'Soudan', valueField: 'SD' },
    { textField: 'Soudan du Sud', valueField: 'SS' },
    { textField: 'Sri Lanka', valueField: 'LK' },
    { textField: 'Suède', valueField: 'SE' },
    { textField: 'Suisse', valueField: 'CH' },
    { textField: 'Suriname', valueField: 'SR' },
    { textField: 'Svalbard et ile Jan Mayen', valueField: 'SJ' },
    { textField: 'Syrie', valueField: 'SY' },
    { textField: 'Tadjikistan', valueField: 'TJ' },
    { textField: 'Taïwan', valueField: 'TW' },
    { textField: 'Tanzanie', valueField: 'TZ' },
    { textField: 'Tchad', valueField: 'TD' },
    { textField: 'Tchéquie', valueField: 'CZ' },
    {
        textField: 'Terres australes et antarctiques françaises',
        valueField: 'TF',
    },
    { textField: "Territoire britannique de l'océan Indien", valueField: 'IO' },
    { textField: 'Thaïlande', valueField: 'TH' },
    { textField: 'Timor oriental', valueField: 'TL' },
    { textField: 'Togo', valueField: 'TG' },
    { textField: 'Tokelau', valueField: 'TK' },
    { textField: 'Tonga', valueField: 'TO' },
    { textField: 'Trinité-et-Tobago', valueField: 'TT' },
    { textField: 'Tunisie', valueField: 'TN' },
    { textField: 'Turkménistan', valueField: 'TM' },
    { textField: 'Turquie', valueField: 'TR' },
    { textField: 'Tuvalu', valueField: 'TV' },
    { textField: 'Ukraine', valueField: 'UA' },
    { textField: 'Uruguay', valueField: 'UY' },
    { textField: 'Vanuatu', valueField: 'VU' },
    { textField: 'Venezuela', valueField: 'VE' },
    { textField: 'Viêt Nam', valueField: 'VN' },
    { textField: 'Wallis-et-Futuna', valueField: 'WF' },
    { textField: 'Yémen', valueField: 'YE' },
    { textField: 'Zambie', valueField: 'ZM' },
    { textField: 'Zimbabwe', valueField: 'ZW' },
];

export const countriesPortuguese = [
    { textField: 'Afeganistão', valueField: 'AF' },
    { textField: 'África do Sul', valueField: 'ZA' },
    { textField: 'Albânia', valueField: 'AL' },
    { textField: 'Alemanha', valueField: 'DE' },
    { textField: 'Andorra', valueField: 'AD' },
    { textField: 'Angola', valueField: 'AO' },
    { textField: 'Anguilla', valueField: 'AI' },
    { textField: 'Antártica', valueField: 'AQ' },
    { textField: 'Antígua e Barbuda', valueField: 'AG' },
    { textField: 'Argentina', valueField: 'AR' },
    { textField: 'Argélia', valueField: 'DZ' },
    { textField: 'Armênia', valueField: 'AM' },
    { textField: 'Aruba', valueField: 'AW' },
    { textField: 'Arábia Saudita', valueField: 'SA' },
    { textField: 'Austrália', valueField: 'AU' },
    { textField: 'Áustria', valueField: 'AT' },
    { textField: 'Azerbaijão', valueField: 'AZ' },
    { textField: 'Bahamas', valueField: 'BS' },
    { textField: 'Bahrein', valueField: 'BH' },
    { textField: 'Bangladesh', valueField: 'BD' },
    { textField: 'Barbados', valueField: 'BB' },
    { textField: 'Bélgica', valueField: 'BE' },
    { textField: 'Belize', valueField: 'BZ' },
    { textField: 'Benin', valueField: 'BJ' },
    { textField: 'Bermudas', valueField: 'BM' },
    { textField: 'Bielorrússia', valueField: 'BY' },
    { textField: 'Bolívia', valueField: 'BO' },
    { textField: 'Bonaire', valueField: 'BQ' },
    { textField: 'Botsuana', valueField: 'BW' },
    { textField: 'Brasil', valueField: 'BR' },
    { textField: 'Brunei Darussalam', valueField: 'BN' },
    { textField: 'Bulgária', valueField: 'BG' },
    { textField: 'Burkina Faso', valueField: 'BF' },
    { textField: 'Bósnia e Herzegovina', valueField: 'BA' },
    { textField: 'Burundi', valueField: 'BI' },
    { textField: 'Butão', valueField: 'BT' },
    { textField: 'Cabo Verde', valueField: 'CV' },
    { textField: 'Camarões', valueField: 'CM' },
    { textField: 'Camboja', valueField: 'KH' },
    { textField: 'Camisa', valueField: 'JE' },
    { textField: 'Canadá', valueField: 'CA' },
    { textField: 'Catar', valueField: 'QA' },
    { textField: 'Cazaquistão', valueField: 'KZ' },
    { textField: 'Chade', valueField: 'TD' },
    { textField: 'Checa', valueField: 'CZ' },
    { textField: 'Chile', valueField: 'CL' },
    { textField: 'China', valueField: 'CN' },
    { textField: 'Chipre', valueField: 'CY' },
    { textField: 'Cingapura', valueField: 'SG' },
    { textField: 'Colômbia', valueField: 'CO' },
    { textField: 'Comores', valueField: 'KM' },
    { textField: 'Congo', valueField: 'CD' },
    { textField: 'Congo', valueField: 'CG' },
    { textField: 'Coréia', valueField: 'KR' },
    { textField: 'Coréia, República Popular Democrática da', valueField: 'KP' },
    { textField: 'Costa Rica', valueField: 'CR' },
    { textField: 'Costa do Marfim', valueField: 'CI' },
    { textField: 'Croácia', valueField: 'HR' },
    { textField: 'Cuba', valueField: 'CU' },
    { textField: 'Curaçao', valueField: 'CW' },
    { textField: 'Dinamarca', valueField: 'DK' },
    { textField: 'Djibuti', valueField: 'DJ' },
    { textField: 'Dominica', valueField: 'DM' },
    { textField: 'Egito', valueField: 'EG' },
    { textField: 'El Salvador', valueField: 'SV' },
    { textField: 'Emirados Árabes Unidos', valueField: 'AE' },
    { textField: 'Equador', valueField: 'EC' },
    { textField: 'Eritreia', valueField: 'ER' },
    { textField: 'Eslováquia', valueField: 'SK' },
    { textField: 'Eslovênia', valueField: 'SI' },
    { textField: 'Espanha', valueField: 'ES' },
    { textField: 'Estados Unidos da America', valueField: 'US' },
    { textField: 'Estônia', valueField: 'EE' },
    { textField: 'Eswatini', valueField: 'SZ' },
    { textField: 'Etiópia', valueField: 'ET' },
    { textField: 'Federação Russa', valueField: 'RU' },
    { textField: 'Fiji', valueField: 'FJ' },
    { textField: 'Filipinas', valueField: 'PH' },
    { textField: 'Finlândia', valueField: 'FI' },
    { textField: 'França', valueField: 'FR' },
    { textField: 'Gabão', valueField: 'GA' },
    { textField: 'Gâmbia', valueField: 'GM' },
    { textField: 'Gana', valueField: 'GH' },
    { textField: 'Geórgia', valueField: 'GE' },
    { textField: 'Geórgia do Sul e Ilhas Sandwich do Sul', valueField: 'GS' },
    { textField: 'Gibraltar', valueField: 'GI' },
    { textField: 'Granada', valueField: 'GD' },
    { textField: 'Grécia', valueField: 'GR' },
    { textField: 'Groenlândia', valueField: 'GL' },
    { textField: 'Guadalupe', valueField: 'GP' },
    { textField: 'Guam', valueField: 'GU' },
    { textField: 'Guatemala', valueField: 'GT' },
    { textField: 'Guernsey', valueField: 'GG' },
    { textField: 'Guiana', valueField: 'GY' },
    { textField: 'Guiana Francesa', valueField: 'GF' },
    { textField: 'Guiné', valueField: 'GN' },
    { textField: 'Guiné Equatorial', valueField: 'GQ' },
    { textField: 'Guiné-Bissau', valueField: 'GW' },
    { textField: 'Haiti', valueField: 'HT' },
    { textField: 'Holanda', valueField: 'NL' },
    { textField: 'Honduras', valueField: 'HN' },
    { textField: 'Hong Kong', valueField: 'HK' },
    { textField: 'Hungria', valueField: 'HU' },
    { textField: 'Iémen', valueField: 'YE' },
    { textField: 'Ilha Bouvet', valueField: 'BV' },
    { textField: 'Ilha Heard e Ilhas McDonald', valueField: 'HM' },
    { textField: 'Ilha Norfolk', valueField: 'NF' },
    { textField: 'Ilha de Man', valueField: 'IM' },
    { textField: 'Ilha do Natal', valueField: 'CX' },
    { textField: 'Ilhas Aland', valueField: 'AX' },
    { textField: 'Ilhas Cayman', valueField: 'KY' },
    { textField: 'Ilhas Cocos (Keeling)', valueField: 'CC' },
    { textField: 'Ilhas Cook', valueField: 'CK' },
    { textField: 'Ilhas Faroe', valueField: 'FO' },
    { textField: 'Ilhas Malvinas', valueField: 'FK' },
    { textField: 'Ilhas Marianas do Norte', valueField: 'MP' },
    { textField: 'Ilhas Marshall', valueField: 'MH' },
    {
        textField: 'Ilhas Menores Distantes dos Estados Unidos',
        valueField: 'UM',
    },
    { textField: 'Ilhas Salomão', valueField: 'SB' },
    { textField: 'Ilhas Turcas e Caicos', valueField: 'TC' },
    { textField: 'Ilhas Virgens (Britânicas)', valueField: 'VG' },
    { textField: 'Ilhas Virgens (EUA)', valueField: 'VI' },
    { textField: 'Índia', valueField: 'IN' },
    { textField: 'Indonésia', valueField: 'ID' },
    { textField: 'Ir', valueField: 'TG' },
    { textField: 'Irã', valueField: 'IR' },
    { textField: 'Iraque', valueField: 'IQ' },
    { textField: 'Irlanda', valueField: 'IE' },
    { textField: 'Islândia', valueField: 'IS' },
    { textField: 'Israel', valueField: 'IL' },
    { textField: 'Itália', valueField: 'IT' },
    { textField: 'Jamaica', valueField: 'JM' },
    { textField: 'Japão', valueField: 'JP' },
    { textField: 'Jordânia', valueField: 'JO' },
    { textField: 'Kiribati', valueField: 'KI' },
    { textField: 'Kuwait', valueField: 'KW' },
    { textField: 'Lesoto', valueField: 'LS' },
    { textField: 'Letônia', valueField: 'LV' },
    { textField: 'Líbano', valueField: 'LB' },
    { textField: 'Libéria', valueField: 'LR' },
    { textField: 'Líbia', valueField: 'LY' },
    { textField: 'Liechtenstein', valueField: 'LI' },
    { textField: 'Lituânia', valueField: 'LT' },
    { textField: 'Luxemburgo', valueField: 'LU' },
    { textField: 'Macau', valueField: 'MO' },
    { textField: 'Madagáscar', valueField: 'MG' },
    { textField: 'Malauí', valueField: 'MW' },
    { textField: 'Maldivas', valueField: 'MV' },
    { textField: 'Mali', valueField: 'ML' },
    { textField: 'Malta', valueField: 'MT' },
    { textField: 'Malásia', valueField: 'MY' },
    { textField: 'Marrocos', valueField: 'MA' },
    { textField: 'Martinica', valueField: 'MQ' },
    { textField: 'Mauritânia', valueField: 'MR' },
    { textField: 'Maurício', valueField: 'MU' },
    { textField: 'Mayotte', valueField: 'YT' },
    { textField: 'México', valueField: 'MX' },
    { textField: 'Mianmar', valueField: 'MM' },
    { textField: 'Micronésia', valueField: 'FM' },
    { textField: 'Moldávia', valueField: 'MD' },
    { textField: 'Mônaco', valueField: 'MC' },
    { textField: 'Mongólia', valueField: 'MN' },
    { textField: 'Montenegro', valueField: 'ME' },
    { textField: 'Montserrat', valueField: 'MS' },
    { textField: 'Moçambique', valueField: 'MZ' },
    { textField: 'Namíbia', valueField: 'NA' },
    { textField: 'Nauru', valueField: 'NR' },
    { textField: 'Nepal', valueField: 'NP' },
    { textField: 'Nicarágua', valueField: 'NI' },
    { textField: 'Níger', valueField: 'NE' },
    { textField: 'Nigéria', valueField: 'NG' },
    { textField: 'Niue', valueField: 'NU' },
    { textField: 'Norte da Macedônia', valueField: 'MK' },
    { textField: 'Noruega', valueField: 'NO' },
    { textField: 'Nova Caledônia', valueField: 'NC' },
    { textField: 'Nova Zelândia', valueField: 'NZ' },
    { textField: 'Omã', valueField: 'OM' },
    { textField: 'Palau', valueField: 'PW' },
    { textField: 'Palestina', valueField: 'PS' },
    { textField: 'Panamá', valueField: 'PA' },
    { textField: 'Papua Nova Guiné', valueField: 'PG' },
    { textField: 'Paquistão', valueField: 'PK' },
    { textField: 'Paraguai', valueField: 'PY' },
    { textField: 'Peru', valueField: 'PE' },
    { textField: 'Peru', valueField: 'TR' },
    { textField: 'Pitcairn', valueField: 'PN' },
    { textField: 'Polinésia Francesa', valueField: 'PF' },
    { textField: 'Polônia', valueField: 'PL' },
    { textField: 'Porto Rico', valueField: 'PR' },
    { textField: 'Portugal', valueField: 'PT' },
    { textField: 'Quirguistão', valueField: 'KG' },
    { textField: 'Quênia', valueField: 'KE' },
    {
        textField: 'Reino Unido da Grã-Bretanha e Irlanda do Norte',
        valueField: 'GB',
    },
    { textField: 'República Árabe da Síria', valueField: 'SY' },
    { textField: 'República Centro-Africana', valueField: 'CF' },
    { textField: 'República Democrática Popular do Laos', valueField: 'LA' },
    { textField: 'República Dominicana', valueField: 'DO' },
    { textField: 'Reunião', valueField: 'RE' },
    { textField: 'Romênia', valueField: 'RO' },
    { textField: 'Ruanda', valueField: 'RW' },
    { textField: 'Saara Ocidental', valueField: 'EH' },
    { textField: 'Saint Pierre e Miquelon', valueField: 'PM' },
    { textField: 'Samoa Americana', valueField: 'AS' },
    { textField: 'Samoa', valueField: 'WS' },
    { textField: 'Santa Helena', valueField: 'SH' },
    { textField: 'Santa Lúcia', valueField: 'LC' },
    { textField: 'Santa Sé', valueField: 'VA' },
    { textField: 'São Bartolomeu', valueField: 'BL' },
    { textField: 'São Cristóvão e Nevis', valueField: 'KN' },
    { textField: 'São Marinho', valueField: 'SM' },
    { textField: 'São Martin (parte francesa)', valueField: 'MF' },
    { textField: 'São Tomé e Príncipe', valueField: 'ST' },
    { textField: 'São Vicente e Granadinas', valueField: 'VC' },
    { textField: 'Sérvia', valueField: 'RS' },
    { textField: 'Seicheles', valueField: 'SC' },
    { textField: 'Senegal', valueField: 'SN' },
    { textField: 'Serra Leoa', valueField: 'SL' },
    { textField: 'Sint Maarten (parte holandesa)', valueField: 'SX' },
    { textField: 'Somália', valueField: 'SO' },
    { textField: 'Sri Lanka', valueField: 'LK' },
    { textField: 'Sudão do Sul', valueField: 'SS' },
    { textField: 'Sudão', valueField: 'SD' },
    { textField: 'Suriname', valueField: 'SR' },
    { textField: 'Suécia', valueField: 'SE' },
    { textField: 'Suíça', valueField: 'CH' },
    { textField: 'Svalbard e Jan Mayen', valueField: 'SJ' },

    { textField: 'Tadjiquistão', valueField: 'TJ' },
    { textField: 'Tailândia', valueField: 'TH' },
    { textField: 'Taiwan', valueField: 'TW' },
    { textField: 'Tanzânia', valueField: 'TZ' },
    { textField: 'Território Britânico do Oceano Índico', valueField: 'IO' },
    { textField: 'Territórios Franceses do Sul', valueField: 'TF' },
    { textField: 'Timor-Leste', valueField: 'TL' },
    { textField: 'Tokelau', valueField: 'TK' },
    { textField: 'Tonga', valueField: 'TO' },
    { textField: 'Trinidad e Tobago', valueField: 'TT' },
    { textField: 'Tunísia', valueField: 'TN' },
    { textField: 'Turcomenistão', valueField: 'TM' },
    { textField: 'Tuvalu', valueField: 'TV' },
    { textField: 'Ucrânia', valueField: 'UA' },
    { textField: 'Uganda', valueField: 'UG' },
    { textField: 'Uruguai', valueField: 'UY' },
    { textField: 'Uzbequistão', valueField: 'UZ' },
    { textField: 'Vanuatu', valueField: 'VU' },
    { textField: 'Venezuela', valueField: 'VE' },
    { textField: 'Vietnã', valueField: 'VN' },
    { textField: 'Wallis e Futuna', valueField: 'WF' },
    { textField: 'Zâmbia', valueField: 'ZM' },
    { textField: 'Zimbábue', valueField: 'ZW' },
];

export const countriesSpanish = [
    { textField: 'Afganistán', valueField: 'AF' },
    { textField: 'Albania', valueField: 'AL' },
    { textField: 'Alemania', valueField: 'DE' },
    { textField: 'Andorra', valueField: 'AD' },
    { textField: 'Angola', valueField: 'AO' },
    { textField: 'Anguila', valueField: 'AI' },
    { textField: 'Antigua y Barbuda', valueField: 'AG' },
    { textField: 'Antártida', valueField: 'AQ' },
    { textField: 'Arabia Saudita', valueField: 'SA' },
    { textField: 'Argelia', valueField: 'DZ' },
    { textField: 'Argentina', valueField: 'AR' },
    { textField: 'Armenia', valueField: 'AM' },
    { textField: 'Aruba', valueField: 'AW' },
    { textField: 'Australia', valueField: 'AU' },
    { textField: 'Austria', valueField: 'AT' },
    { textField: 'Azerbaiyán', valueField: 'AZ' },
    { textField: 'Bahamas', valueField: 'BS' },
    { textField: 'Bahréin', valueField: 'BH' },
    { textField: 'Bangladés', valueField: 'BD' },
    { textField: 'Barbados', valueField: 'BB' },
    { textField: 'Belice', valueField: 'BZ' },
    { textField: 'Benín', valueField: 'BJ' },
    { textField: 'Bielorrusia', valueField: 'BY' },
    { textField: 'Birmania', valueField: 'MM' },
    { textField: 'Bolivia', valueField: 'BO' },
    { textField: 'Bonaire', valueField: 'BQ' },
    { textField: 'Bosnia y Herzegovina', valueField: 'BA' },
    { textField: 'Botsuana', valueField: 'BW' },
    { textField: 'Brasil', valueField: 'BR' },
    { textField: 'Brunei Darussalam', valueField: 'BN' },
    { textField: 'Bulgaria', valueField: 'BG' },
    { textField: 'Burkina Faso', valueField: 'BF' },
    { textField: 'Burundi', valueField: 'BI' },
    { textField: 'Bután', valueField: 'BT' },
    { textField: 'Bélgica', valueField: 'BE' },
    { textField: 'Cabo Verde', valueField: 'CV' },
    { textField: 'Camboya', valueField: 'KH' },
    { textField: 'Camerún', valueField: 'CM' },
    { textField: 'Canadá', valueField: 'CA' },
    { textField: 'Chad', valueField: 'TD' },
    { textField: 'Chequia', valueField: 'CZ' },
    { textField: 'Chile', valueField: 'CL' },
    { textField: 'Chipre', valueField: 'CY' },
    { textField: 'Colombia', valueField: 'CO' },
    { textField: 'Comoras', valueField: 'KM' },
    { textField: 'Congo', valueField: 'CD' },
    { textField: 'Congo', valueField: 'CG' },
    { textField: 'Corea', valueField: 'KR' },
    { textField: 'Costa Rica', valueField: 'CR' },
    { textField: 'Costa de marfil', valueField: 'CI' },
    { textField: 'Croacia', valueField: 'HR' },
    { textField: 'Cuba', valueField: 'CU' },
    { textField: 'Curazao', valueField: 'CW' },
    { textField: 'Dinamarca', valueField: 'DK' },
    { textField: 'Dominica', valueField: 'DM' },
    { textField: 'Ecuador', valueField: 'EC' },
    { textField: 'Egipto', valueField: 'EG' },
    { textField: 'El Salvador', valueField: 'SV' },
    { textField: 'Emiratos Árabes Unidos', valueField: 'AE' },
    { textField: 'Eritrea', valueField: 'ER' },
    { textField: 'Eslovaquia', valueField: 'SK' },
    { textField: 'Eslovenia', valueField: 'SI' },
    { textField: 'España', valueField: 'ES' },
    { textField: 'Estados Unidos de América', valueField: 'US' },
    { textField: 'Estonia', valueField: 'EE' },
    { textField: 'Esuatini', valueField: 'SZ' },
    { textField: 'Etiopía', valueField: 'ET' },
    { textField: 'Federación Rusa', valueField: 'RU' },
    { textField: 'Filipinas', valueField: 'PH' },
    { textField: 'Finlandia', valueField: 'FI' },
    { textField: 'Fiyi', valueField: 'FJ' },
    { textField: 'Francia', valueField: 'FR' },
    { textField: 'Gabón', valueField: 'GA' },
    { textField: 'Gambia', valueField: 'GM' },
    {
        textField: 'Georgia del sur y las islas Sandwich del sur',
        valueField: 'GS',
    },
    { textField: 'Georgia', valueField: 'GE' },
    { textField: 'Ghana', valueField: 'GH' },
    { textField: 'Gibraltar', valueField: 'GI' },
    { textField: 'Granada', valueField: 'GD' },
    { textField: 'Grecia', valueField: 'GR' },
    { textField: 'Groenlandia', valueField: 'GL' },
    { textField: 'Guadalupe', valueField: 'GP' },
    { textField: 'Guam', valueField: 'GU' },
    { textField: 'Guatemala', valueField: 'GT' },
    { textField: 'Guayana Francesa', valueField: 'GF' },
    { textField: 'Guayana', valueField: 'GY' },
    { textField: 'Guernesey', valueField: 'GG' },
    { textField: 'Guinea Ecuatorial', valueField: 'GQ' },
    { textField: 'Guinea', valueField: 'GN' },
    { textField: 'Guinea-Bisáu', valueField: 'GW' },
    { textField: 'Haití', valueField: 'HT' },
    { textField: 'Honduras', valueField: 'HN' },
    { textField: 'Hong Kong', valueField: 'HK' },
    { textField: 'Hungría', valueField: 'HU' },
    { textField: 'India', valueField: 'IN' },
    { textField: 'Indonesia', valueField: 'ID' },
    { textField: 'Irak', valueField: 'IQ' },
    { textField: 'Irlanda', valueField: 'IE' },
    { textField: 'Irán', valueField: 'IR' },
    { textField: 'Isla Bouvet', valueField: 'BV' },
    { textField: 'Isla Norfolk', valueField: 'NF' },
    { textField: 'Isla de Navidad', valueField: 'CX' },
    { textField: 'Isla del hombre', valueField: 'IM' },
    { textField: 'Islandia', valueField: 'IS' },
    { textField: 'Islas Aland', valueField: 'AX' },
    { textField: 'Islas Bermudas', valueField: 'BM' },
    { textField: 'Islas Caimán', valueField: 'KY' },
    { textField: 'Islas Cocos (Keeling)', valueField: 'CC' },
    { textField: 'Islas Cook', valueField: 'CK' },
    { textField: 'Islas Faroe', valueField: 'FO' },
    { textField: 'Islas Heard y McDonald', valueField: 'HM' },
    { textField: 'Islas Malvinas', valueField: 'FK' },
    { textField: 'Islas Marianas del Norte', valueField: 'MP' },
    { textField: 'Islas Marshall', valueField: 'MH' },
    { textField: 'Islas Salomón', valueField: 'SB' },
    { textField: 'Islas Turcas y Caicos', valueField: 'TC' },
    { textField: 'Islas Vírgenes (EE. UU.)', valueField: 'VI' },
    { textField: 'Islas Vírgenes (británicas)', valueField: 'VG' },
    {
        textField: 'Islas ultramarinas menores de los Estados Unidos',
        valueField: 'UM',
    },
    { textField: 'Israel', valueField: 'IL' },
    { textField: 'Italia', valueField: 'IT' },
    { textField: 'Jamaica', valueField: 'JM' },
    { textField: 'Japón', valueField: 'JP' },
    { textField: 'Jersey', valueField: 'JE' },
    { textField: 'Jordán', valueField: 'JO' },
    { textField: 'Katar', valueField: 'QA' },
    { textField: 'Kazajstán', valueField: 'KZ' },
    { textField: 'Kenia', valueField: 'KE' },
    { textField: 'Kirguistán', valueField: 'KG' },
    { textField: 'Kiribati', valueField: 'KI' },
    { textField: 'Kuwait', valueField: 'KW' },
    { textField: 'Lesoto', valueField: 'LS' },
    { textField: 'Letonia', valueField: 'LV' },
    { textField: 'Liberia', valueField: 'LR' },
    { textField: 'Libia', valueField: 'LY' },
    { textField: 'Liechtenstein', valueField: 'LI' },
    { textField: 'Lituania', valueField: 'LT' },
    { textField: 'Luxemburgo', valueField: 'LU' },
    { textField: 'Líbano', valueField: 'LB' },
    { textField: 'Macao', valueField: 'MO' },
    { textField: 'Macedonia del Norte', valueField: 'MK' },
    { textField: 'Madagascar', valueField: 'MG' },
    { textField: 'Malasia', valueField: 'MY' },
    { textField: 'Malaui', valueField: 'MW' },
    { textField: 'Maldivas', valueField: 'MV' },
    { textField: 'Malta', valueField: 'MT' },
    { textField: 'Malí', valueField: 'ML' },
    { textField: 'Marruecos', valueField: 'MA' },
    { textField: 'Martinica', valueField: 'MQ' },
    { textField: 'Mauricio', valueField: 'MU' },
    { textField: 'Mauritania', valueField: 'MR' },
    { textField: 'Mayotte', valueField: 'YT' },
    { textField: 'Micronesia', valueField: 'FM' },
    { textField: 'Moldavia', valueField: 'MD' },
    { textField: 'Mongolia', valueField: 'MN' },
    { textField: 'Monserrat', valueField: 'MS' },
    { textField: 'Montenegro', valueField: 'ME' },
    { textField: 'Mozambique', valueField: 'MZ' },
    { textField: 'México', valueField: 'MX' },
    { textField: 'Mónaco', valueField: 'MC' },
    { textField: 'Namibia', valueField: 'NA' },
    { textField: 'Nauru', valueField: 'NR' },
    { textField: 'Nepal', valueField: 'NP' },
    { textField: 'Nicaragua', valueField: 'NI' },
    { textField: 'Nigeria', valueField: 'NG' },
    { textField: 'Niue', valueField: 'NU' },
    { textField: 'Noruega', valueField: 'NO' },
    { textField: 'Nueva Caledonia', valueField: 'NC' },
    { textField: 'Nueva Zelanda', valueField: 'NZ' },
    { textField: 'Níger', valueField: 'NE' },
    { textField: 'Omán', valueField: 'OM' },
    { textField: 'Países Bajos', valueField: 'NL' },
    { textField: 'Pakistán', valueField: 'PK' },
    { textField: 'Palaus', valueField: 'PW' },
    { textField: 'Palestina', valueField: 'PS' },
    { textField: 'Panamá', valueField: 'PA' },
    { textField: 'Papúa Nueva Guinea', valueField: 'PG' },
    { textField: 'Para llevar', valueField: 'TG' },
    { textField: 'Paraguay', valueField: 'PY' },
    { textField: 'Pavo', valueField: 'TR' },
    { textField: 'Perú', valueField: 'PE' },
    { textField: 'Pitcairn', valueField: 'PN' },
    { textField: 'Polinesia francés', valueField: 'PF' },
    { textField: 'Polonia', valueField: 'PL' },
    { textField: 'Porcelana', valueField: 'CN' },
    { textField: 'Portugal', valueField: 'PT' },
    { textField: 'Puerto Rico', valueField: 'PR' },
    {
        textField: 'Reino Unido de Gran Bretaña e Irlanda del Norte',
        valueField: 'GB',
    },
    { textField: 'República Árabe Siria', valueField: 'SY' },
    { textField: 'República Centroafricana', valueField: 'CF' },
    {
        textField: 'República de Corea, Popular Democrática de',
        valueField: 'KP',
    },
    { textField: 'República Democrática Popular Lao', valueField: 'LA' },
    { textField: 'República Dominicana', valueField: 'DO' },
    { textField: 'Reunión', valueField: 'RE' },
    { textField: 'Ruanda', valueField: 'RW' },
    { textField: 'Rumania', valueField: 'RO' },
    { textField: 'Sahara Occidental', valueField: 'EH' },
    { textField: 'Samoa', valueField: 'WS' },
    { textField: 'Samoa Americana', valueField: 'AS' },
    { textField: 'San Bartolomé', valueField: 'BL' },
    { textField: 'San Cristóbal y Nieves', valueField: 'KN' },
    { textField: 'San Marino', valueField: 'SM' },
    { textField: 'San Martín (parte francesa)', valueField: 'MF' },
    { textField: 'San Pedro y Miquelón', valueField: 'PM' },
    { textField: 'San Vicente y las Granadinas', valueField: 'VC' },
    { textField: 'Santa Elena', valueField: 'SH' },
    { textField: 'Santa Lucía', valueField: 'LC' },
    { textField: 'Santa Sede', valueField: 'VA' },
    { textField: 'Santo Tomé y Príncipe', valueField: 'ST' },
    { textField: 'Senegal', valueField: 'SN' },
    { textField: 'Serbia', valueField: 'RS' },
    { textField: 'Seychelles', valueField: 'SC' },
    { textField: 'Sierra Leona', valueField: 'SL' },
    { textField: 'Singapur', valueField: 'SG' },
    { textField: 'Sint Maarten (parte holandesa)', valueField: 'SX' },
    { textField: 'Somalia', valueField: 'SO' },
    { textField: 'Sri Lanka', valueField: 'LK' },
    { textField: 'Sudáfrica', valueField: 'ZA' },
    { textField: 'Sudán del Sur', valueField: 'SS' },
    { textField: 'Sudán', valueField: 'SD' },
    { textField: 'Suecia', valueField: 'SE' },
    { textField: 'Suiza', valueField: 'CH' },
    { textField: 'Surinam', valueField: 'SR' },
    { textField: 'Svalbard y Jan Mayen', valueField: 'SJ' },
    { textField: 'Tailandia', valueField: 'TH' },
    { textField: 'Taiwán', valueField: 'TW' },
    { textField: 'Tanzania', valueField: 'TZ' },
    { textField: 'Tayikistán', valueField: 'TJ' },
    { textField: 'Territorio Británico del Océano Índico', valueField: 'IO' },
    { textField: 'Territorios Franceses del Sur', valueField: 'TF' },
    { textField: 'Timor Oriental', valueField: 'TL' },
    { textField: 'Tokelau', valueField: 'TK' },
    { textField: 'Tonga', valueField: 'TO' },
    { textField: 'Trinidad y Tobago', valueField: 'TT' },
    { textField: 'Túnez', valueField: 'TN' },
    { textField: 'Turkmenistán', valueField: 'TM' },
    { textField: 'Tuvalu', valueField: 'TV' },
    { textField: 'Ucrania', valueField: 'UA' },
    { textField: 'Uganda', valueField: 'UG' },
    { textField: 'Uruguay', valueField: 'UY' },
    { textField: 'Uzbekistán', valueField: 'UZ' },
    { textField: 'Vanuatu', valueField: 'VU' },
    { textField: 'Venezuela', valueField: 'VE' },
    { textField: 'Vietnam', valueField: 'VN' },
    { textField: 'Wallis y Futuna', valueField: 'WF' },
    { textField: 'Yemen', valueField: 'YE' },
    { textField: 'Yibuti', valueField: 'DJ' },
    { textField: 'Zambia', valueField: 'ZM' },
    { textField: 'Zimbabue', valueField: 'ZW' },
];
export const supportedCountriesEnglish = [
    { textField: 'United States of America', valueField: 'US' },
];
